import Vue from 'vue';
import Router from 'vue-router';
import Index from '@views/home/Index';
import NotDefined from '@views/NotDefined';
import $store from '../store';
import Loading from '@views/Loading';
import cookie from '@utils/store/cookie';
import toLogin from '@libs/login';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            meta: {
                title: '涪城区文化馆',
                keepAlive: true,
                footer: true,
                auth: false,
                header: false
            },
            component: Index
        },
        {
            path: '/classes/:id',
            name: 'Classes',
            meta: {
                title: '课程详情',
                keepAlive: true,
                header: false,
                auth: false
            },
            component: () => import('@views/classes/Detail.vue')
        },
        {
            path: '/user',
            name: 'User',
            meta: {
                title: '我的',
                keepAlive: true,
                header: false,
                auth: false,
                footer: true
            },
            component: () => import('@views/user/Index.vue')
        },
        {
            path: '/classroom',
            name: 'Classroom',
            meta: {
                title: '课堂瞬间',
                keepAlive: true,
                header: false,
                auth: false,
                footer: true
            },
            component: () => import('@views/classroom/Index.vue')
        },
        {
            path: '/user/authenticate',
            name: 'Authenticate',
            meta: {
                title: '个人认证',
                keepAlive: true,
                header: false,
                auth: true
            },
            component: () => import('@views/user/Authenticate.vue')
        },
        {
            path: '/user/profile',
            name: 'UserProfile',
            meta: {
                title: '个人资料',
                keepAlive: true,
                header: false,
                auth: true
            },
            component: () => import('@views/user/Profile.vue')
        },
        {
            path: '/user/classes',
            name: 'UserClasses',
            meta: {
                title: '参与的课程',
                keepAlive: true,
                header: false,
                auth: true
            },
            component: () => import('@views/user/Classes.vue')
        },
        {
            path: '/auth/:url',
            name: 'Loading',
            meta: {
                title: ' 加载中',
                keepAlive: true
            },
            component: Loading
        },
        {
            path: '*',
            name: 'NotDefined',
            meta: {
                title: '页面找不到',
                keepAlive: true,
                home: false,
                header: false
            },
            component: NotDefined
        },
        {
            path: '/news/detail/:id',
            name: 'NewsDetail',
            meta: {
                title: '文章详情',
                keepAlive: true,
                auth: false,
                header: false
            },
            component: () => import('@views/news/NewsDetail.vue')
        },
        {
            path: '/news',
            name: 'NewsList',
            meta: {
                title: '文章列表',
                keepAlive: true,
                auth: false,
                header: false
            },
            component: () => import('@views/news/NewsList.vue')
        },
        {
            path: '/venue',
            name: 'Venue',
            meta: {
                title: '场馆预约',
                keepAlive: true,
                auth: false,
                header: false
            },
            component: () => import('@views/venue/Index.vue')
        },
        {
            path: '/venue/detail/:id',
            name: 'venueDetail',
            meta: {
                title: '场馆详情',
                keepAlive: true,
                auth: false,
                header: false
            },
            component: () => import('@views/venue/Detail.vue')
        },
        {
            path: '/user/reserve',
            name: 'userReserve',
            meta: {
                title: '我的预约',
                keepAlive: true,
                auth: true,
                header: false
            },
            component: () => import('@views/user/Reserve.vue')
        },
        {
            path: '/classes/sign/:id',
            name: 'ClassesSign',
            meta: {
                title: '签到',
                keepAlive: true,
                header: false,
                auth: true
            },
            component: () => import('@views/classes/Sign.vue')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        // 异步滚动操作
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({ x: 0, y: to.meta.scrollTop || 0 });
            }, 100);
        });
    }
});

router.onError(error => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        // 强制刷新当前网页
        window.location.reload();
    } else {
        //其他错误自行处理
        console.log(error);
        window.location.reload();
    }
});

const { back, replace } = router;

router.back = function() {
    this.isBack = true;
    back.call(router);
};
router.replace = function(...args) {
    this.isReplace = true;
    replace.call(router, ...args);
};

router.beforeEach((to, from, next) => {
    const { title, backgroundColor, footer, auth, header } = to.meta;

    $store.commit('SHOW_LOADING');

    if (auth === true && !$store.state.app.token) {
        if (from.name === 'Login') return;
        $store.commit('LOGOUT');
        cookie.set('login_back_url', to.fullPath);
        return toLogin();
        // return next({
        //     path: '/login',
        //     query: { redirect: to.fullPath }
        // });
    }

    document.title = title || process.env.VUE_APP_NAME || '';
    //判断是否显示底部导航
    footer === true ? $store.commit('SHOW_FOOTER') : $store.commit('HIDE_FOOTER');
    //判断是否显示顶部导航
    let isShowHeader = header === true || header === undefined;
    isShowHeader ? $store.commit('SHOW_HEADER') : $store.commit('HIDE_HEADER');
    isShowHeader && $store.commit('HEADER_TITLE', title);

    $store.commit('BACKGROUND_COLOR', backgroundColor || '');
    $store.commit('HEADER_RIGHT', null);

    if (auth) {
        $store
            .dispatch('USERINFO')
            .then(res => {
                if (res == undefined) {
                    $store.commit('LOGOUT');
                    // next({
                    //     path: '/login',
                    //     query: { redirect: to.fullPath }
                    // });
                    toLogin();
                } else {
                    next();
                }
            })
            .catch(() => {
                $store.commit('LOGOUT');
                // next({
                //     path: '/login',
                //     query: { redirect: to.fullPath }
                // });
                toLogin();
            });
    } else next();
});
router.afterEach(() => {
    // const { auth } = to.meta;to, from
    $store.commit('HIDE_LOADING');

    // if (auth) {
    //     if (from.name === 'Login') return;
    //     setTimeout(() => {
    //         $store.dispatch('USERINFO', true);
    //     }, 1000);
    // }
});
export default router;
